import { v4 as uuidv4 } from 'uuid';

// Type definitions for FBQ
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}

const PIXEL_ID = import.meta.env.VITE_FACEBOOK_PIXEL_ID;

// Helper to generate unique Event IDs for deduplication
export const generateEventId = (): string => {
  return uuidv4();
};

// Initialize Pixel
export const initPixel = () => {
  if (!PIXEL_ID) {
    console.warn('Meta Pixel ID not found in environment variables.');
    return;
  }

  if (window.fbq) return;

  // Standard Meta Pixel Code
  /* eslint-disable */
  (function(f:any, b:any, e:any, v:any, n?:any, t?:any, s?:any){
    if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)
  })(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */

  window.fbq('init', PIXEL_ID);
};

// Unified Track Event (Browser + Server)
type StandardEvents = 
  | 'PageView'
  | 'ViewContent' 
  | 'Search' 
  | 'AddToCart' 
  | 'InitiateCheckout' 
  | 'AddPaymentInfo' 
  | 'Purchase' 
  | 'Lead' 
  | 'Contact' 
  | 'CompleteRegistration';

interface EventData {
  currency?: string;
  value?: number;
  content_ids?: string[];
  content_type?: string;
  content_name?: string;
  num_items?: number;
  search_string?: string;
  [key: string]: any;
}

interface UserData {
  em?: string; // Email (will be hashed by server)
  ph?: string; // Phone (will be hashed by server)
  fn?: string; // First Name
  ln?: string; // Last Name
  [key: string]: any;
}

export const trackPixelEvent = async (
  eventName: StandardEvents, 
  data: EventData = {}, 
  userData: UserData = {}
) => {
  if (!PIXEL_ID) return;

  const eventId = generateEventId();

  // 1. Browser Tracking (Pixel)
  if (window.fbq) {
    // Note: We don't pass userData to 'track' standard calls usually, 
    // unless using Advanced Matching with 'init'. 
    // For simplicity, we stick to standard events here.
    window.fbq('track', eventName, data, { eventID: eventId });
  }

  // 2. Server Tracking (CAPI)
  try {
    const payload = {
      eventName,
      eventId,
      eventSourceUrl: window.location.href,
      userData, // Server will hash this
      customData: data
    };

    // Fire and forget (don't await to avoid blocking UI)
    fetch('/api/meta-conversion', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    }).catch(err => console.error('CAPI Error:', err));

  } catch (error) {
    console.warn('Error sending event to CAPI:', error);
  }
};
